import axios from 'axios';

const instance = axios.create({ baseURL: 'https://adhamo-messages-server.herokuapp.com' });
// const instance = axios.create({ baseURL: 'http://localhost:8080' });
// const instance = axios.create({ baseURL: 'https://adhamo-messages-server.glitch.me' });

export default instance;